import React from 'react'

interface MobileBackdropProps {
  isOpen: boolean
  onClick: () => void
}

export const MobileBackdrop: React.FC<MobileBackdropProps> = ({
  isOpen,
  onClick
}) => {
  if (!isOpen) {
    return null
  }

  return (
    <div
      onClick={onClick}
      className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm transition-all duration-250 ease-in-out z-40 md:hidden"
      aria-hidden="true"
      data-testid="mobile-backdrop"
    />
  )
}
